import React from 'react';
import {
  DotLoader,
  CircleLoader,
  BounceLoader,
  RingLoader,
} from 'react-spinners';
import { CircularProgress } from '@material-ui/core';

export interface LoaderProps {
  loaderType?: 'ring' | 'dot' | 'circle' | 'bounce';
  color?: string;
}

interface LoaderComponentProps {
  color?: string;
  htmlColor?: string;
}

export const Loader: React.FC<LoaderProps> = ({ loaderType, color }) => {
  const props: LoaderComponentProps = {};
  if (color) {
    props.color = color;
    props.htmlColor = color;
  }
  switch (loaderType) {
    case 'ring':
      return <RingLoader {...props} />;
    case 'dot':
      return <DotLoader {...props} />;
    case 'circle':
      return <CircleLoader {...props} />;
    case 'bounce':
      return <BounceLoader {...props} />;
    default:
      return <CircularProgress color="primary" />;
  }
};
